/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Role_CandidateInputs */

const en_admin_user_list_role_candidate = /** @type {(inputs: Admin_User_List_Role_CandidateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidate`)
};

const de_admin_user_list_role_candidate = /** @type {(inputs: Admin_User_List_Role_CandidateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kandidat`)
};

/**
* | output |
* | --- |
* | "Candidate" |
*
* @param {Admin_User_List_Role_CandidateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_role_candidate = /** @type {((inputs?: Admin_User_List_Role_CandidateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Role_CandidateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_role_candidate(inputs)
	return en_admin_user_list_role_candidate(inputs)
});